import "swiper/css";
import "swiper/css/free-mode";

import React from "react";
import { Autoplay, FreeMode, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import ChokwinCasinoIcon from "@pages/casino/assets/backgrounds/chokwin-casino-icon.webp";
import DefaultCasinoIcon from "@pages/casino/assets/backgrounds/default-casino-icon.png";

import {
	ContentWrapper,
	GameName,
	Name,
	ProviderImgWrapper,
	TenantWrapper,
	Won,
} from "./elements.jsx";
import useController from "./useController";

const CasinoIcon = window.TENANT === "chokwin" ? ChokwinCasinoIcon : DefaultCasinoIcon;

const swiperOptions = {
	modules: [Autoplay],
	autoplay: {
		delay: 3000,
		disableOnInteraction: true,
		pauseOnMouseEnter: true,
	},
	rewind: true,
	speed: 400,
	spaceBetween: 10,
	slidesPerView: "auto",
	slidesOffsetBefore: 20,
	slidesOffsetAfter: 20,
};

const WinnersSlider = ({ colorful }) => {
	const {
		helpers: { translate },
		state: { lastWinners, isLoading },
		handlers: { handleSliderItemClick },
	} = useController();

	if (lastWinners?.length === 0 || isLoading) return null;

	return (
		<ProviderImgWrapper colorful={colorful}>
			<Swiper
				slidesPerView={1}
				freeMode={true}
				modules={[FreeMode, Pagination]}
				{...swiperOptions}>
				{lastWinners?.map((win, index) => (
					<SwiperSlide key={win?.id || index}>
						<TenantWrapper onClick={() => handleSliderItemClick(win)}>
							{window.WON_SLIDER_ICON ? (
								<img
									src={window.WON_SLIDER_ICON}
									width={41}
									height={24}
								/>
							) : (
								<img
									src={win?.icon_custom_url || win?.game_icon_url || CasinoIcon}
									width={41}
									height={24}
								/>
							)}
							<ContentWrapper>
								<Name>{win?.givenName}</Name>
								<Won>
									{colorful ? (
										<>
											{win?.amount} {win?.currency}
										</>
									) : (
										translate("casino.justWon", {
											amount: win?.amount,
											currency: win?.currency,
										})
									)}
								</Won>
								{!colorful && <GameName>{win?.gameRemoteName}</GameName>}
							</ContentWrapper>
						</TenantWrapper>
					</SwiperSlide>
				))}
			</Swiper>
		</ProviderImgWrapper>
	);
};

export default WinnersSlider;
